import React from 'react'
import PropTypes from 'prop-types'
import ClaimSearchView from './ClaimSearchView'
import _ from 'lodash'
import PROPTYPES from '../../../lib/propTypes'

class ClaimsView extends React.Component {
  static defaultProps = {
    getClaimsJobs: _.noop,
  }

  static propTypes = {
    sites: PROPTYPES.sites,
    prescribers: PROPTYPES.prescribers,
    ui: PropTypes.shape({
      isFetchingSites: PropTypes.bool,
      isFetchingPrescribers: PropTypes.bool,
    }),
    getPrescribers: PropTypes.func,
    getClaimsJobs: PropTypes.func
  }
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount () {
    this.props.getSites()
    this.props.getPrescribers()
  }

  render () {
    return (
      <div style={{ textAlign: 'left' }}>
        <ClaimSearchView
          isFetchingSites={this.props.ui.isFetchingSites}
          isFetchingPrescribers={this.props.ui.isFetchingPrescribers}
          sites={this.props.sites}
          prescribers={this.props.prescribers}
          getClaimsJobs={this.props.getClaimsJobs}
        />
      </div>
    )
  }
}

export default ClaimsView



// WEBPACK FOOTER //
// ./src/routes/Claims/components/ClaimsView.jsx